import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Button } from 'react-bootstrap';
import { formValueSelector } from 'redux-form';
import ExternalEntryForm from './ExternalEntryForm';
import BlitzAPI from '../../../api/BlitzAPI';
import { handleFormErrors } from '../../form/utils';
import SpinLoader from '../../form/SpinLoader';

class ExternalEntryCreate extends Component {
  constructor(props) {
    super(props);
    this.state = {
      entry: null,
      parsingUrl: false,
    };
    this.handleSubmit = this.handleSubmit.bind(this);
    this.parseEntryFromUrl = this.parseEntryFromUrl.bind(this);
  }

  handleSubmit(values) {
    return BlitzAPI.postEntry({ entry: values }).catch(
      handleFormErrors,
    );
  }

  parseEntryFromUrl() {
    const { url } = this.props;
    if (url) {
      this.setState({ parsingUrl: true });
      BlitzAPI.parseEntryFromUrl({ url }).then(
        (response) => {
          this.setState({ entry: response.data.data, parsingUrl: false });
        },
      );
    }
  }

  render() {
    const { url } = this.props;
    const { entry, parsingUrl } = this.state;
    return (
      <div>
        <h1 className="create-header">Import an External Content</h1>
        <Button
          className="button-secondary create-form-button-parse"
          type="button"
          onClick={this.parseEntryFromUrl}
          disabled={parsingUrl}
        >Parse from URL</Button>
        { parsingUrl && <SpinLoader
          style={{
            'margin-left': '8px',
            top: '296px',
            width: '12px',
            height: '12px',
            position: 'relative',
            display: 'inline-block',
          }}
        /> }
        <ExternalEntryForm
          onSubmit={this.handleSubmit}
          initialValues={entry || { show_mobile: true, show_web: true, type: 'article', is_blitz: false }}
          url={url}
        />
      </div>
    );
  }
}

const selector = formValueSelector('generic-entry');
function mapStateToProps(state) {
  const url = selector(state, 'url');
  const type = selector(state, 'type');
  return {
    url,
    type,
  };
}

ExternalEntryCreate.propTypes = {
  url: PropTypes.string,
};

export default connect(
  mapStateToProps,
)(ExternalEntryCreate);



// WEBPACK FOOTER //
// ./src/cms/entry/external/ExternalEntryCreate.js